import { BaseComponent } from '../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { selectNewInvoice, selectVatCodes } from '../../selectors';
import { selectConfig, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_UPDATE_INVOICE, REQUEST_VAT_CODES } from '../../constants';
import { Card } from '../../../../components/Card';
import { Checkbox } from '../../../../components/Checkbox';
import { CompanySelection } from '../../../Companies/components/CompanySelection';
import { TypeSelection } from '../TypeSelection';
import { VBox } from '../../../../components/Box';
import { Loader } from '../../../../components/Loader';
import { Row, Cell, List } from '../../../../components/List';
import { InvoiceStatus } from '../InvoiceStatus';

import { PurchaseField } from './FieldsPurchase';
import { setNewInvoiceValue, updateInvoice, updateInvoiceStatus } from '../../actions';
import { StatusSelection } from '../StatusSelection';
import { selectVehicle } from '../../../Vehicles/selectors';
import { getPropByName } from '../../../../utils/props';
import { BtwOrMarge } from '../../constants';

import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { ViesLabel } from '../../../Companies/components/ViesLabel';
import { getDate } from '../../../Vehicles/helpers';
import { INCOMING_CREDIT_LIMIT_NOT_ENOUGH } from '../../../../utils/request';
import { Modal, ModalControls } from '../../../../components/Modal';
import { Button } from '../../../../components/Buttons';



const Container = styled.div`
  font-size: 14px;
  h3 {
    font-size: 20px;
  }
  .type {
    color: #6c757d;
  }
  .regplate {
  }

  .status-label {
    width: fit-content;
  }

  .secondary-info {
    white-space: nowrap;
    padding: 0 4px;
    font-weight: 600;
    color: #6e6e6e;
    border-right: ${props => (props.width <= 768 ? 'none' : '1.5px solid #6e6e6e')};
  }
  .secondary-info-list {
    color: #6e6e6e;
    font-weight: 600;
  }
`;

const STATE = {
  email: false,
  statusEdit: false,
  incomingCompanyEdit: false,
  selectedCompanyId: null,
  selectedCompanyLabel: null,
};
/* eslint-disable react/prefer-stateless-function */
class InvoicePurchaseInfoCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  get dto() {
    return {
      incomingCompanyId: this.getFieldValue('incomingCompanyId'),
    };
  }

  get invoiceStatus() {
    return this.getFieldValue('statusLabel') ?? 'OPEN';
  }

  get type() {
    return this.getFieldValue('typeLabel')?.toUpperCase() ?? '';
  }

  get vatCodes() {
    return this.props.vatCodes ?? [];
  }

  get vatCodeOptions() {
    return this.vatCodes.map(vatCode => {
      return { value: vatCode.code, label: `${vatCode.code} : ${vatCode.description}` };
    });
  }

  get vehiclesubject() {
    const vehicleSubject = this.props.invoice?.invoiceSubjects.filter(sub => sub?.type == 'vehicle')[0];
    return vehicleSubject;
  }

  get vehicleRestBPM() {
    const bpm = getPropByName(this.props.invoiceVehicle, 'rest_bpm');
    return bpm;
  }

  formatAmount(amount) {
    if (amount === undefined || amount === null) return 0;
    return typeof amount == 'string' ? parseFloat(amount?.replace(',', '.')) : +amount;
  }

  get financialTotalAmountBtw() {
    let tempPrice = this.props.invoice?.financialTotalAmount;
    // console.log('------------------------------');
    // console.log('------------------------------');
    // console.log('------------------------------');
    // console.log('this.props', this.props);
    // console.log('this.props.values?.financial_purchase_price_incl_vat_bpm', this.props.values?.financial_purchase_price_incl_vat_bpm);
    // console.log('tempPrice', tempPrice);
    // console.log('this.props.vehicleSubjectPrice', this.props.vehicleSubjectPrice);
    // console.log('total', tempPrice - +this.props.vehicleSubjectPrice);
    // console.log('result', tempPrice - +this.props.vehicleSubjectPrice + +this.props.values?.financial_purchase_price_incl_vat_bpm);
    //
    // console.log('------------------------------');
    // console.log('------------------------------');
    // console.log('------------------------------');

    if (this.props.values?.financial_purchase_price_incl_vat_bpm) {
      let total = tempPrice - +this.props.vehicleSubjectPrice;
      this.props.setValue(
        (total + +this.props.values?.financial_purchase_price_incl_vat_bpm).toFixed(2),
        'financialTotalAmount',
      );
      return total + +this.props.values?.financial_purchase_price_incl_vat_bpm;
    }

    if (this.props.values?.financial_purchase_price_incl_vat_excl_bpm) {
      let total = tempPrice - +this.props.vehicleSubjectPrice;
      this.props.setValue(
        (total + +this.props.values?.financial_purchase_price_incl_vat_excl_bpm).toFixed(2),
        'financialTotalAmount',
      );
      return total + +this.props.values?.financial_purchase_price_incl_vat_excl_bpm;
    }
    
    if (
      !this.props.values?.financial_purchase_price_incl_vat_excl_bpm ||
      this.props.values?.financial_purchase_price_incl_vat_excl_bpm === 0 ||
      !this.props.values?.financial_purchase_price_incl_vat_bpm ||
      this.props.values?.financial_purchase_price_incl_vat_bpm
    ) {
      this.props.setValue((tempPrice - +this.props.vehicleSubjectPrice).toFixed(2), 'financialTotalAmount');
      return tempPrice - +this.props.vehicleSubjectPrice;
    }

    return;
  }

  get financialTotalAmountMarge() {
    let tempPrice = this.props.invoice?.financialTotalAmount;
    tempPrice = typeof tempPrice == 'string' ? parseFloat(tempPrice.replace(',', '.')) : +tempPrice;
    
    if (
      this.props.values?.financial_purchase_price_marge_bpm ||
      this.props.values?.financial_purchase_price_marge_excl_bpm
    ) {
      let total = tempPrice - +this.props.vehicleSubjectPrice;
      
      // Use the available price value
      let margePrice = this.props.values?.financial_purchase_price_marge_bpm || this.props.values?.financial_purchase_price_marge_excl_bpm;
      let sum = +total + this.formatAmount(margePrice);
      
      this.props.setValue(sum.toFixed(2), 'financialTotalAmount');

      return total + this.formatAmount(margePrice);
    }
    
    this.props.setValue(+tempPrice.toFixed(2), 'financialTotalAmount');

    return +tempPrice;
  }

  getFieldValue(fieldName) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }
    return this.props.invoice[fieldName];
  }

  onChangeTypeSelection(type) {
    this.setState(prev => {
      return { ...prev, selectedTypeLabel: type.label, selectedType: type.id };
    });
  }

  getFieldValue(fieldName, object) {
    if (Object.keys(this.state).includes(fieldName)) {
      return this.state[fieldName];
    }

    if (fieldName == 'statusLabel') {
      return this.props.invoice?.statusLabel;
    }
    if (fieldName == 'typeLabel') {
      return this.props.invoice?.typeLabel;
    }

    if (object == 'invoice') {
      return this.props.invoice[fieldName];
    }

    if (fieldName == 'addresses') {
      return this.props.invoice?.incomingCompany[fieldName] || [];
    }
    return this.props.invoice?.incomingCompany[fieldName];
  }

  onEditIncomingCompany() {
    this.setState(prev => {
      return { ...prev, incomingCompanyEdit: true };
    });
  }

  onChangeCompanySelection(company) {
    this.setState(prev => {
      return { ...prev, selectedCompanyLabel: company.name ?? company.name ?? '', selectedCompanyId: company.id };
    });
  }

  closeIncomingCompanyEdit() {
    this.setState(prev => {
      return { ...prev, incomingCompanyEdit: false, selectedCompanyId: null, selectedCompanyLabel: null };
    });
  }

  onChangeIncomingCompany() {
    this.setState({ loading: true });
    return this.onUpdate({ incomingCompanyId: this.getFieldValue('selectedCompanyId') }, res => {
      if (res.id) {
        ['addresses', 'IBAN', 'BTW_number', 'customernumber', 'company_from_eu'].map(type =>
          this.props.setValue(res?.incomingCompany[type], type),
        );
      }
    });
  }

  onChangeStatusSelection(status) {
    this.setState(prev => {
      return { ...prev, selectedStatusLabel: status.label, selectedStatus: status.id };
    });
  }

  onChangeTypeSelection(type) {
    this.setState(prev => {
      return { ...prev, selectedTypeLabel: type.label, selectedType: type.id };
    });
  }

  onChangeStatus() {
    this.props.updateInvoiceStatus(this.state.selectedStatus, () => {
      this.setState(prev => {
        return {
          ...prev,
          statusLabel: prev.selectedStatusLabel,
          status: prev.selectedStatus,
          statusEdit: false,
          selectedStatus: null,
          selectedStatusLabel: null,
        };
      });
    });
  }

  onChangeType() {
    this.setState(prev => {
      return {
        ...prev,
        typeLabel: prev.selectedTypeLabel,
        type: prev.selectedType,
        typeEdit: false,
        selectedType: null,
        selectedTypeLabel: null,
      };
    });
  }

  onEditStatus() {
    this.setState(prev => {
      return { ...prev, statusEdit: true };
    });
  }

  onEditType() {
    this.setState(prev => {
      return { ...prev, typeEdit: true };
    });
  }

  closeStatusEdit() {
    this.setState(prev => {
      return { ...prev, statusEdit: false, selectedStatus: null, selectedStatusLabel: null };
    });
  }

  closeTypeEdit() {
    this.setState(prev => {
      return { ...prev, typeEdit: false, selectedType: null, selectedTypeLabel: null };
    });
  }

  renderStatusEdit() {
    if (!this.state.statusEdit) return '';
    if (!this.props.serverConfig.manualPaymentStatus) return this.renderStatusEditStub();

    return (
      <ModalComponent title={this.lbl('invoice.invoice_status')} onClose={this.closeStatusEdit.bind(this)}>
        {this.state.selectedStatus ? (
          <VBox>{this.lbl('translate.' + this.state.selectedStatusLabel)}</VBox>
        ) : (
          <StatusSelection onSelect={this.onChangeStatusSelection.bind(this)} />
        )}
        <div className="mt-2 d-flex gap-2">
          <ButtonComponent style="ButtonSoftEdit" onClick={this.onChangeStatus.bind(this)}>
            {this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.closeStatusEdit.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderStatusEditStub() {
    return (
      <ModalComponent title={this.lbl('status')} onClose={this.closeStatusEdit.bind(this)}>
        {this.lbl('invoice.statusEditStubMsg')}
        <div className="mt-2 d-flex gap-2">
          <ButtonComponent style="ButtonSoftDelete" onClick={this.closeStatusEdit.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderTypeEdit() {
    if (!this.state.typeEdit) return '';

    return (
      <ModalComponent title={this.lbl('confirm')}>
        {this.state.selectedType ? (
          <VBox>{this.state.selectedTypeLabel}</VBox>
        ) : (
          <TypeSelection onSelect={this.onChangeTypeSelection.bind(this)} />
        )}
        <div className="mt-2 d-flex gap-2">
          <ButtonComponent style="ButtonSoftEdit" onClick={this.onChangeType.bind(this)}>
            {this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.closeTypeEdit.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  renderIncomingCompanyEdit() {
    if (!this.getFieldValue('incomingCompanyEdit', 'invoice')) return '';

    return (
      <ModalComponent title={this.lbl('confirm')}>
        {this.state.selectedCompanyId ? (
          <VBox>{this.state.selectedCompanyLabel}</VBox>
        ) : (
          <CompanySelection
            order
            user={{ id: this.getFieldValue('incomingCompanyId', 'invoice') }}
            onSelect={this.onChangeCompanySelection.bind(this)}
          />
        )}
        {this.state.loading && <Loader small />}
        <div className="mt-2 d-flex gap-2">
          <ButtonComponent
            style="ButtonSoftEdit"
            disabled={this.state.loading}
            onClick={this.onChangeIncomingCompany.bind(this)}
          >
            {this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style="ButtonSoftDelete" onClick={this.closeIncomingCompanyEdit.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  onUpdate(dto, callback) {
    this.props.update(dto, callback);
  }

  getReset() {
    this.setState({ email: false });
  }

  get isNotShowBpmFields() {
    if (this.props.serverConfig?.disableBPM) return true;
    if (
      (this.props.values?.import === '0' || this.props.values?.import === false) &&
      this.props.values?.vehiclePurpose === 'commercial' &&
      this.props.values?.btwOrMarge === 'BTW' &&
      this.props.vehicle?.tax_year !== '2025'
    ) {
      return true;
    }

    if (
      (this.props.values?.import === '0' || this.props.values?.import === false) &&
      this.props.values?.vehiclePurpose &&
      this.props.values?.btwOrMarge === 'marge'
    ) {
      return true;
    }

    if (
      (this.props.values?.import === '1' || this.props.values?.import === true) &&
      this.props.values?.vehiclePurpose &&
      this.props.values?.btwOrMarge === 'BTW'
    ) {
      return true;
    }

    if (
      (this.props.values?.import === '1' || this.props.values?.import === true) &&
      this.props.values?.vehiclePurpose &&
      this.props.values?.btwOrMarge === 'marge'
    ) {
      return true;
    }

    return false;
  }

  toggleProformaPurchasePaid() {
    this.props.update({ proformaPurchasePaid: !this.props.invoice?.proformaPurchasePaid }, res => {
      if (res?.message === INCOMING_CREDIT_LIMIT_NOT_ENOUGH) this.setState({ creditLimitWarning: true });
    });
  }

  cancelCreditLimitModal() {
    this.setState({ creditLimitWarning: false });
  }

  applyCreditLimitModal() {
    this.props.update({ proformaPurchasePaid: !this.props.invoice?.proformaPurchasePaid, skipCreditLimitCheck: true });
  }

  renderCreditLimitWarningModal() {
    if (!this.state.creditLimitWarning) return '';

    return (
      <Modal onClose={this.cancelCreditLimitModal.bind(this)} title={this.lbl('invoice.credit_limit_exceeded')}>
        <ModalControls>
          <Button isPrimary onClick={this.applyCreditLimitModal.bind(this)}>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.cancelCreditLimitModal.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }

  render() {
    const vehicle = this.props.vehicle;
    const invoice = this.props.invoice;
    console.log('___ this.isNotShowBpmFields', this.isNotShowBpmFields);
    return (
      <Card className="vehicle-info-card info-card info wide">
        <Container width={window.innerWidth}>
          {this.renderIncomingCompanyEdit()}
          {this.renderStatusEdit()}
          {this.renderTypeEdit()}
          {this.renderCreditLimitWarningModal()}
          <h2>{this.lbl('invoice.details.card.purchasing_data')}</h2>
          <List>
            <Row key={'type'}>
              <Cell>{this.lbl(`invoice.create.type`)}</Cell>
              <Cell>
                <InvoiceStatus onClick={this.onEditType.bind(this)} className="status-label" status={this.type} />
              </Cell>
            </Row>
            <Row key={'direction'}>
              <Cell>{this.lbl(`invoice.create.direction`)}</Cell>
              <Cell>
                {`${this.type} ${this.props.invoice?.direction?.toUpperCase()}`}
                {/* <InvoiceStatus onClick={this.onEditType.bind(this)} className="status-label" status={this.type} /> */}
              </Cell>
            </Row>

            {['referenceNumber', 'date'].map(type => (
              <PurchaseField
                vehicleSubject={this.vehiclesubject}
                restBPM={this.vehicleRestBPM}
                key={type}
                type={type}
                vehicle={vehicle}
                invoice={invoice}
                vehicleSubjectPrice={this.props.vehicleSubjectPrice}
                total={
                  this.props.values.btwOrMarge == BtwOrMarge.MARGE
                    ? this.financialTotalAmountMarge
                    : this.financialTotalAmountBtw
                }
              />
            ))}
            {['vehiclePurpose', 'btwOrMarge'].map(type => (
              <PurchaseField
                isRequire={this.props.isRequire}
                options={this.vatCodeOptions}
                vehicleSubject={this.vehiclesubject}
                restBPM={this.vehicleRestBPM}
                key={type}
                type={type}
                invoice={invoice}
                vehicle={vehicle}
                showRecalculateButton={true}
              />
            ))}
            {this.props.secondaryTypes()?.map((type, index) => {
              if (index == 0) {
                return (
                  <PurchaseField
                    isRequire={this.props.isRequire}
                    options={this.vatCodeOptions}
                    vehicleSubject={this.vehiclesubject}
                    restBPM={this.vehicleRestBPM}
                    key={type}
                    type={type}
                    invoice={invoice}
                    vehicle={vehicle}
                    showRecalculateButton={true}
                  />
                );
              }
            })}
            {this.props.values?.btwOrMarge !== 'marge' &&
              ['vat_amount', 'vatCode'].map(type => (
                <PurchaseField
                  isRequire={this.props.isRequire}
                  options={this.vatCodeOptions}
                  vehicleSubject={this.vehiclesubject}
                  restBPM={this.vehicleRestBPM}
                  key={type}
                  type={type}
                  invoice={invoice}
                  vehicle={vehicle}
                />
              ))}
            {this.props.secondaryTypes()?.map((type, index) => {
              if (index != 0) {
                return (
                  <PurchaseField
                    isRequire={this.props.isRequire}
                    options={this.vatCodeOptions}
                    vehicleSubject={this.vehiclesubject}
                    restBPM={this.vehicleRestBPM}
                    key={type}
                    type={type}
                    invoice={invoice}
                    vehicle={vehicle}
                  />
                );
              }
            })}
            {!this.isNotShowBpmFields &&
              ['rest_bpm', 'financial_bpm_gross', 'financialTotalAmount'].map(type => {
                
                let totalValue;
                if (this.props.values.btwOrMarge == BtwOrMarge.MARGE) {
                  totalValue = this.financialTotalAmountMarge;
                } else {
                  totalValue = this.financialTotalAmountBtw;
                }
                
                return (
                  <PurchaseField
                    isRequire={this.props.isRequire}
                    options={this.vatCodeOptions}
                    vehicleSubject={this.vehiclesubject}
                    restBPM={this.vehicleRestBPM}
                    key={type}
                    type={type}
                    invoice={invoice}
                    vehicle={vehicle}
                    vehicleSubjectPrice={this.props.vehicleSubjectPrice}
                    total={totalValue}
                    showRecalculateButton={true}
                  />
                );
              })}
            {this.isNotShowBpmFields &&
              ['financialTotalAmount'].map(type => {
                
                let totalValue;
                if (this.props.values.btwOrMarge == BtwOrMarge.MARGE) {
                  totalValue = this.financialTotalAmountMarge;
                } else {
                  totalValue = this.financialTotalAmountBtw;
                }
                
                return (
                  <PurchaseField
                    isRequire={this.props.isRequire}
                    options={this.vatCodeOptions}
                    vehicleSubject={this.vehiclesubject}
                    restBPM={this.vehicleRestBPM}
                    key={type}
                    type={type}
                    invoice={invoice}
                    vehicle={vehicle}
                    vehicleSubjectPrice={this.props.vehicleSubjectPrice}
                    total={totalValue}
                    showRecalculateButton={true}
                  />
                );
              })}
            <Row key={'invoiceStatus'}>
              <Cell>{this.lbl(`invoice.create.status`)}</Cell>
              <Cell>
                <InvoiceStatus onClick={this.onEditStatus.bind(this)} className="status-label" status={this.invoiceStatus} />
              </Cell>
            </Row>
            {['paidDate'].map(type => (
              <PurchaseField
                vehicleSubject={this.vehiclesubject}
                restBPM={this.vehicleRestBPM}
                key={type}
                type={type}
                invoice={invoice}
                vehicle={vehicle}
              />
            ))}

            <Row key={'type_finalized'}>
              <Cell>{this.lbl(`invoice.create.finalized`)}</Cell>
              <Cell>
                <Checkbox disabled={true} checked={invoice?.isFinal} />
              </Cell>
            </Row>
            {['entryNumber'].map(type => (
              <PurchaseField
                vehicleSubject={this.vehiclesubject}
                restBPM={this.vehicleRestBPM}
                key={type}
                type={type}
                invoice={invoice}
                vehicle={vehicle}
              />
            ))}
            <Row key="proformaPurchasePaid">
              <Cell>{this.lbl(`invoice.create.proformaPurchasePaid`)}</Cell>
              <Cell>
                {this.props.workEdit ? (
                  <Loader small />
                ) : (
                  <Checkbox onChange={this.toggleProformaPurchasePaid.bind(this)} checked={invoice?.proformaPurchasePaid} />
                )}
              </Cell>
            </Row>
          </List>
        </Container>
      </Card>
    );
  }
}

InvoicePurchaseInfoCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: selectNewInvoice(),
    vatCodes: selectVatCodes(),
    work: selectWorks([REQUEST_VAT_CODES]),
    invoiceVehicle: selectVehicle(ownProps.vehicle?.id),
    serverConfig: selectConfig(),
    workEdit: selectWork(REQUEST_UPDATE_INVOICE),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    update(dto, callback) {
      dispatch(updateInvoice(ownProps.invoice?.id, dto, callback));
    },
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewInvoiceValue(name, value));
    },
    updateInvoiceStatus(statusId, callback) {
      dispatch(updateInvoiceStatus(ownProps.invoice?.id, statusId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const InvoicePurchaseInfoCard = compose(withConnect, withRouter)(InvoicePurchaseInfoCardComp);
